import { Content, ContentHeader } from "@backstage/core-components";
import { Card, Divider, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { IssueForm } from "../IssueForm/IssueForm";
import { useEntity } from "@backstage/plugin-catalog-react";

const useStyles = makeStyles((_theme: Theme) => ({
  card: {
    position: "relative",
  },
}));

export interface Props {}

export const IssueFormOverview: React.FC<Props> = (): JSX.Element => {
  const classes = useStyles();

  const e = useEntity();
  const entity = e.entity;

  return (
    <Card className={classes.card}>
      <Content>
        <ContentHeader title="Submit a Jira Issue for this Entity" />
        <Divider />
        <IssueForm entity={entity} />
      </Content>
    </Card>
  );
};
